// Behaviour for the "From the set" product block and the "Complete the gift" cart upsell.
// Loaded once per page from snippets/cart-drawer.liquid. It has to live outside the
// widgets' own markup: the upsell only appears when the cart drawer re-renders, and
// scripts inserted by that re-render never run.
import { addLines } from './range-cart-add.js';

if (!customElements.get('product-set')) {
  customElements.define('product-set', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[data-ref="add"]');
      const message = this.querySelector('[data-ref="message"]');
      if (!button || button.dataset.wired) return;
      button.dataset.wired = '1';
      button.addEventListener('click', async () => {
        const ids = (this.dataset.ids || '').split(',').filter(Boolean);
        if (!ids.length) return;
        button.disabled = true;
        if (message) message.textContent = '';
        const result = await addLines(this, ids.map((id) => ({ id, quantity: 1 })), 'product-set');
        button.disabled = false;
        if (!result.ok && message) message.textContent = result.message || 'Some of the set could not be added.';
      });
    }
  });
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.wired) return;
      this.dataset.wired = '1';
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-variant]');
        if (!button || button.disabled) return;
        button.disabled = true;
        const result = await addLines(this, [{ id: button.dataset.variant, quantity: 1 }], 'cart-upsell');
        if (!result.ok) { button.disabled = false; button.textContent = 'Try again'; }
      });
    }
  });
}
